import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  initiatedBeforeTitle: {
    defaultMessage: 'Your payment is already on its way',
    id: 'DuplicatePayment.initiatedBeforeTitle',
  },
  initiatedBeforeText: {
    defaultMessage: 'No further action required.',
    id: 'DuplicatePayment.initiatedBeforeText',
  },
  failedTitle: {
    defaultMessage: 'This link has expired',
    id: 'DuplicatePayment.failedTitle',
  },
  failedText: {
    defaultMessage: 'Please try another payment method.',
    id: 'DuplicatePayment.failedText',
  },
  customerMessage: {
    defaultMessage: 'Payment retry is not allowed',
    id: 'DuplicatePayment.customerMessage',
  },
});
